import { render, staticRenderFns } from "./references.vue?vue&type=template&id=f4d62d0c"
import script from "./references.vue?vue&type=script&lang=ts"
export * from "./references.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports